(function () {
  'use strict';

  const STORAGE_KEY = '1947_recent_searches';
  const MAX_RECENT = 8;
  const DEBOUNCE_MS = 250;

  const overlay = document.getElementById('search-overlay');
  if (!overlay) return;

  const input = overlay.querySelector('#search-overlay-input');
  const form = overlay.querySelector('#search-overlay-form');
  const backBtn = overlay.querySelector('[data-search-overlay-close]');
  const browsePanel = overlay.querySelector('[data-search-browse]');
  const resultsPanel = overlay.querySelector('[data-search-results]');
  const recentWrap = overlay.querySelector('[data-recent-searches]');
  const recentSection = overlay.querySelector('[data-recent-section]');
  const clearRecentBtn = overlay.querySelector('[data-clear-recent]');
  const searchUrl = window.routes?.search_url || '/search';

  let debounceTimer = null;
  let abortController = null;

  function getRecent() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function saveRecent(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_RECENT)));
    } catch (e) {
      /* ignore */
    }
  }

  function addRecent(term) {
    const value = (term || '').trim();
    if (!value) return;
    const next = [value, ...getRecent().filter((item) => item.toLowerCase() !== value.toLowerCase())];
    saveRecent(next);
    renderRecent();
  }

  function renderRecent() {
    if (!recentWrap || !recentSection) return;
    const items = getRecent();
    recentSection.hidden = items.length === 0;
    if (!items.length) {
      recentWrap.innerHTML = '';
      return;
    }

    recentWrap.innerHTML = items
      .map(
        (term) => `
        <span class="search-overlay__tag search-overlay__tag--recent">
          <button type="button" class="search-overlay__tag-term" data-term="${escapeAttr(term)}">${escapeHtml(term)}</button>
          <button type="button" class="search-overlay__tag-remove" data-remove-term="${escapeAttr(term)}" aria-label="Remove ${escapeAttr(term)}">×</button>
        </span>`
      )
      .join('');
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, '&#39;');
  }

  function openOverlay() {
    overlay.classList.add('is-open');
    overlay.removeAttribute('hidden');
    document.body.classList.add('search-overlay-open');
    renderRecent();
    showBrowse();
    window.setTimeout(() => input?.focus(), 50);
  }

  function closeOverlay() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('hidden', '');
    document.body.classList.remove('search-overlay-open');
    if (input) input.value = '';
    showBrowse();
    if (abortController) abortController.abort();
  }

  function showBrowse() {
    if (browsePanel) browsePanel.hidden = false;
    if (resultsPanel) {
      resultsPanel.hidden = true;
      resultsPanel.innerHTML = '';
    }
  }

  function showResults(html) {
    if (browsePanel) browsePanel.hidden = true;
    if (resultsPanel) {
      resultsPanel.hidden = false;
      resultsPanel.innerHTML = html;
    }
  }

  function runSearch(term, saveToRecent) {
    const value = (term || '').trim();
    if (!value) return;
    if (saveToRecent) addRecent(value);
    window.location.href = `${searchUrl}?q=${encodeURIComponent(value)}&options%5Bprefix%5D=last`;
  }

  function fetchResults(term) {
    const value = (term || '').trim();
    if (!value) {
      showBrowse();
      return;
    }

    if (!window.routes?.predictive_search_url) {
      showResults(`<p class="so-empty-results">Press enter to search for "${escapeHtml(value)}"</p>`);
      return;
    }

    if (abortController) abortController.abort();
    abortController = new AbortController();

    showResults('<p class="so-loading">Searching…</p>');

    const url = `${window.routes.predictive_search_url}?q=${encodeURIComponent(value)}&section_id=search-overlay-results&resources[type]=product&resources[limit]=8`;

    fetch(url, { signal: abortController.signal })
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const section = doc.querySelector('#shopify-section-search-overlay-results');
        showResults(section ? section.innerHTML : '<p class="so-empty-results">No results found.</p>');
      })
      .catch((error) => {
        if (error?.name === 'AbortError') return;
        showResults('<p class="so-empty-results">Something went wrong. Try again.</p>');
      });
  }

  document.querySelectorAll('.search-overlay-trigger').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openOverlay();
    });
  });

  backBtn?.addEventListener('click', closeOverlay);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
      closeOverlay();
    }
  });

  overlay.querySelectorAll('[data-trending-term]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const term = btn.getAttribute('data-trending-term') || btn.textContent;
      if (input) input.value = term;
      runSearch(term, true);
    });
  });

  recentWrap?.addEventListener('click', (event) => {
    const removeBtn = event.target.closest('[data-remove-term]');
    if (removeBtn) {
      event.stopPropagation();
      const term = removeBtn.getAttribute('data-remove-term');
      saveRecent(getRecent().filter((item) => item !== term));
      renderRecent();
      return;
    }

    const termBtn = event.target.closest('[data-term]');
    if (termBtn) {
      const term = termBtn.getAttribute('data-term');
      if (input) input.value = term;
      runSearch(term, false);
    }
  });

  clearRecentBtn?.addEventListener('click', () => {
    saveRecent([]);
    renderRecent();
  });

  input?.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    const value = input.value.trim();
    debounceTimer = setTimeout(() => fetchResults(value), DEBOUNCE_MS);
  });

  form?.addEventListener('submit', (event) => {
    event.preventDefault();
    runSearch(input?.value, true);
  });

  renderRecent();
})();
